import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { useInputSize } from '../../../internal/hooks';
import { getInputAdornmentStyles } from '../../styles';
import * as buttonStyles from './styles.module.css';
/**
 * Прозрачная кнопка с отступами для использования в качестве декорации инпута
 */
export var InputAdornmentButton = /*#__PURE__*/React.forwardRef(function InputAdornmentButton(props, ref) {
  var size = useInputSize();
  var styles = getInputAdornmentStyles(size);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button"
  }, props, {
    ref: ref,
    className: cx(styles['input-adornment'], buttonStyles['button'])
  }));
});